import { connect } from 'react-redux';
import ReportDataTable from '../components/reports/LocationReport';

const mapStateToProps = (state, ownProps) => ({
  data: state.reports.locationReport,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportDataTable);
